<template>
  <el-dialog
    title="出票"
    :visible.sync="visible"
    width="800px"
    :before-close="handleClose"
  >
    <el-form
      ref="ticketForm"
      :model="formData"
      :rules="rules"
      label-width="150px"
      v-loading="loading"
    >
      <el-form-item label="巴士公司订单号" prop="ticket_sn">
        <el-input v-model="formData.ticket_sn" placeholder="请输入巴士公司订单号"></el-input>
      </el-form-item>

      <el-form-item label="预留电话" prop="ticket_tel">
        <el-input v-model="formData.ticket_tel" placeholder="请输入预留电话"></el-input>
      </el-form-item>

      <el-form-item label="お支払い" prop="ticket_pay">
        <el-radio-group v-model="formData.ticket_pay">
          <el-radio label="済み">済み</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="备注" prop="ticket_note">
        <el-input
          type="textarea"
          v-model="formData.ticket_note"
          :rows="3"
          placeholder="请输入备注"
        ></el-input>
      </el-form-item>

      <el-form-item label="订票原价(日元)" prop="ticket_org_amount">
        <el-input-number
          v-model="formData.ticket_org_amount"
          :precision="2"
          :min="0"
          style="width: 100%"
        ></el-input-number>
      </el-form-item>

      <!-- 联系人信息 -->
      <div v-if="contacts.length > 0">
        <h4 style="margin: 20px 0 10px 0; color: #606266;">联系人信息</h4>
        <el-form-item
          v-for="contact in contacts"
          :key="contact.id"
          :label="`${contact.name} ${contact.sex} ${contact.age}`"
          :prop="`contact_${contact.id}`"
          :rules="contact.status === 1 ? [{ required: true, message: '请输入日文姓名', trigger: 'blur' }] : []"
        >
          <el-input
            v-if="contact.status === 1"
            v-model="formData[`contact_${contact.id}`]"
            placeholder="请输入日文姓名"
          ></el-input>
          <span v-else style="color: #909399;">已退款</span>
        </el-form-item>
      </div>

      <el-form-item label="显示为" prop="ticket_show_type">
        <el-radio-group v-model="formData.ticket_show_type">
          <el-radio :label="1">附件</el-radio>
          <el-radio :label="2">链接</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="链接" prop="ticket_link" v-if="formData.ticket_show_type === 2">
        <el-input v-model="formData.ticket_link" placeholder="请输入链接地址"></el-input>
      </el-form-item>

      <el-form-item label="附件" prop="file" v-if="formData.ticket_show_type === 1">
        <el-upload
          ref="upload"
          :action="uploadUrl"
          :on-success="handleUploadSuccess"
          :on-error="handleUploadError"
          :file-list="fileList"
          :limit="1"
          :auto-upload="true"
          name="file"
          accept=".pdf,.jpg,.jpeg,.png"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">支持PDF、JPG、PNG文件，最大20MB</div>
        </el-upload>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import axios from 'axios'

export default {
  name: 'OrderTicketDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      loading: false,
      submitting: false,
      orderData: null,
      contacts: [],
      fileList: [],
      uploadUrl: `${ this.base_url}/upload-file`,
      formData: {
        ticket_sn: '',
        ticket_tel: '050-5327-0918',
        ticket_pay: '済み',
        ticket_note: '',
        ticket_org_amount: 0,
        ticket_show_type: 1,
        ticket_link: '',
        file: ''
      },
      rules: {
        ticket_sn: [
          { required: true, message: '请输入巴士公司订单号', trigger: 'blur' }
        ],
        ticket_tel: [
          { required: true, message: '请输入预留电话', trigger: 'blur' }
        ],
        ticket_org_amount: [
          { required: true, message: '请输入订票原价', trigger: 'blur' }
        ]
      }
    }
  },
 
  watch: {
    visible(newVal) {
      if (newVal && this.orderId) {
        this.loadOrderData()
      }
    },
    orderId(newVal) {
      if (newVal && this.visible) {
        this.loadOrderData()
      }
    }
  },
  methods: {
    async loadOrderData() {
      if (!this.orderId) return
      
      this.loading = true
      try {
        const orderData = await this.getOrderOne(this.orderId)
        if (orderData) {
          this.orderData = orderData
          this.initFormData(orderData)
        }
      } catch (error) {
        console.error('加载订单数据失败:', error)
        this.$message.error('加载订单数据失败')
      } finally {
        this.loading = false
      }
    },

    async getOrderOne(orderId) {
      try {
        const response = await axios.get(`${this.base_url}/orders/getOrderOne/${orderId}`)
        if (response.status === 200 && response.data.code) {
          return response.data.data
        } else {
          this.$message.error('获取订单信息失败')
          return null
        }
      } catch (error) {
        console.error('获取订单信息失败:', error)
        this.$message.error('获取订单信息失败')
        return null
      }
    },

    initFormData(orderData) {
      // 初始化表单数据
      this.formData = {
        ticket_sn: orderData.ticket_sn || '',
        ticket_tel: orderData.ticket_tel || '050-5327-0918',
        ticket_pay: '済み',
        ticket_note: orderData.ticket_note || '',
        ticket_org_amount: orderData.ticket_org_amount || this.calculateOrgAmount(orderData),
        ticket_show_type: orderData.ticket_show_type || 1,
        ticket_link: orderData.ticket_link || '',
        file: orderData.file || ''
      }

      // 初始化联系人数据
      this.contacts = orderData.contacts || []
      this.contacts.forEach(contact => {
        this.$set(this.formData, `contact_${contact.id}`, contact.jp_name || '')
      })

      // 初始化文件列表
      if (orderData.file) {
        this.fileList = [{
          name: orderData.file,
          url: orderData.file
        }]
      } else {
        this.fileList = []
      }
    },

    calculateOrgAmount(orderData) {
      // 计算原价：如果没有设置原价，则根据联系人数量计算
      if (orderData.ticket_org_amount && orderData.ticket_org_amount > 0) {
        return orderData.ticket_org_amount
      }
      
      let amount = 0
      if (orderData.contacts && orderData.org_one_price) {
        orderData.contacts.forEach(contact => {
          if (contact.status === 1) {
            amount += orderData.org_one_price
          }
        })
      }
      return amount
    },

    handleUploadSuccess(response, file) {
      if (response.code === 1 && response.data) {
        this.formData.file = response.data.path
        this.$message.success(response.msg || '文件上传成功')
      } else {
        this.$message.error(response.error || '文件上传失败')
      }
    },

    handleUploadError(error) {
      console.error('文件上传失败:', error)
      let errorMsg = '文件上传失败'
      if (error.response && error.response.data && error.response.data.error) {
        errorMsg = error.response.data.error
      }
      this.$message.error(errorMsg)
    },

    async handleSubmit() {
      try {
        const valid = await this.$refs.ticketForm.validate()
        if (!valid) return

        this.submitting = true
        
        // 构建提交数据
        const submitData = {
          ...this.formData,
          id: this.orderId
        }

        // 如果订单状态为1，设置为2并添加出票时间
        if (this.orderData && this.orderData.status === 1) {
          submitData.status = 2
          submitData.ticket_time = new Date().toISOString().slice(0, 19).replace('T', ' ')
        }

        // 处理日元金额转换（这里需要实现jp2cn函数或在后端处理）
        if (submitData.ticket_org_amount) {
          // submitData.ticket_org_amount_cn = this.jp2cn(submitData.ticket_org_amount)
        }

        console.log('提交数据:', submitData)
        
        // 调用出票接口（假的地址）
        const response = await axios.post(`${this.base_url}/orders/ticket`, submitData)
        
        if (response.status === 200 && response.data.code) {
          this.$message.success('出票成功')
          this.$emit('success')
          this.handleClose()
        } else {
          this.$message.error(response.data.message || '出票失败')
        }
      } catch (error) {
        console.error('出票失败:', error)
        this.$message.error('出票失败')
      } finally {
        this.submitting = false
      }
    },

    handleClose() {
      this.$emit('update:visible', false)
      this.resetForm()
    },

    resetForm() {
      if (this.$refs.ticketForm) {
        this.$refs.ticketForm.resetFields()
      }
      this.formData = {
        ticket_sn: '',
        ticket_tel: '050-5327-0918',
        ticket_pay: '済み',
        ticket_note: '',
        ticket_org_amount: 0,
        ticket_show_type: 1,
        ticket_link: '',
        file: ''
      }
      this.contacts = []
      this.fileList = []
      this.orderData = null
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}

.el-form-item {
  margin-bottom: 20px;
}

h4 {
  border-left: 4px solid #409EFF;
  padding-left: 10px;
}
</style>